import React from 'react'
import GroupItemsList from '../GroupItemsList'


const items = [
    {
        title : 'Estructuras y Obras Civiles',
        icon : 'home',
        items : [
            { name : 'Estructuras Subestaciones', link : '/estructuras-subestaciones' },
            { name : 'Elementos Est. Subestaciones', subitemId: 'otrasEstructurasSSEE', 
                subitems : [
                    { name : 'Accesorios Estructuras Subestaciones', link : '/accesorios-estructuras-subestaciones' },
                ]
            },
            { name : 'Estructuras Líneas', link : '/estructuras-lineas' },
            { name : 'Estructuras Líneas Aéreas', subitemId: 'estructurasLineasAereas', 
                subitems : [
                    { name : 'Torres', link : '/torres' },
                    { name : 'Marcos de Línea', link : '/marcos-lineas' },
                    { name : 'Accesorios Estructuras Líneas Aéreas', link : '/accesorios-estructuras-lineas-aereas' },
                ]
            },
            { name : 'Estructuras Líneas Subterraneas', subitemId: 'estructurasLineasSubte', 
                subitems : [
                    { name : 'Cámaras', link : '/camaras' },
                    { name : 'Patios de Mufas', link : '/patios-mufas' },
                    { name : 'Accesorios Estructuras', link : '/accesorios-estructuras-lineas-subterraneas' },
                ]
            },
            { name : 'Otros Elementos Estructuras Líneas', subitemId: 'otrosElemEstLineas', 
                subitems : [
                    { name : 'Mufas', link : '/mufas' },
                    { name : 'Pararrayos Mufas', link : '/pararrayos-mufas' },
                ]
            },
            { name : 'Obras Civiles', link : '/oocc' },
            { name : 'Tipos OO.CC.', link : '/tipos-oocc' },
        ]
    }
]


const EstructurasList = (props) => (
    <GroupItemsList title={"Estructuras y Obras Civiles"} groupItems={items}/>
)

export default EstructurasList